// @flow

import React from "react";

type Props = {
  withCharactersLimit: boolean,
  currentLength: number,
};

export const PostWidgetCharactersLength = (props: Props) =>
  props.withCharactersLimit ? (
    <div className="post-widget-characters-length">
      <strong className="text-orange">{props.currentLength}</strong>{" "}
      <strong>Characters Left</strong>
    </div>
  ) : null;

export default PostWidgetCharactersLength;
